"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCallShiftCreateDtoStipendPayoutOptionEnum = void 0;
exports.instanceOfOnCallShiftCreateDto = instanceOfOnCallShiftCreateDto;
exports.OnCallShiftCreateDtoFromJSON = OnCallShiftCreateDtoFromJSON;
exports.OnCallShiftCreateDtoFromJSONTyped = OnCallShiftCreateDtoFromJSONTyped;
exports.OnCallShiftCreateDtoToJSON = OnCallShiftCreateDtoToJSON;
exports.OnCallShiftCreateDtoToJSONTyped = OnCallShiftCreateDtoToJSONTyped;
/**
 * @export
 */
exports.OnCallShiftCreateDtoStipendPayoutOptionEnum = {
    OnCallbackOnly: 'ON_CALLBACK_ONLY',
    Always: 'ALWAYS'
};
/**
 * Check if a given object implements the OnCallShiftCreateDto interface.
 */
function instanceOfOnCallShiftCreateDto(value) {
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('stipendPayoutOption' in value) || value['stipendPayoutOption'] === undefined)
        return false;
    return true;
}
function OnCallShiftCreateDtoFromJSON(json) {
    return OnCallShiftCreateDtoFromJSONTyped(json, false);
}
function OnCallShiftCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalRate': json['totalRate'],
        'minutesWorked': json['minutesWorked'] == null ? undefined : json['minutesWorked'],
        'stipendPayoutOption': json['stipendPayoutOption'],
    };
}
function OnCallShiftCreateDtoToJSON(json) {
    return OnCallShiftCreateDtoToJSONTyped(json, false);
}
function OnCallShiftCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalRate': value['totalRate'],
        'minutesWorked': value['minutesWorked'],
        'stipendPayoutOption': value['stipendPayoutOption'],
    };
}
//# sourceMappingURL=OnCallShiftCreateDto.js.map